import { getTimeWithTimeZone } from 'utility/general';

const useReviewerFeedback = () => {
    const columns = [
        {
            field: 'name',
            headerName: 'Name',
            width: 120,
        },
        {
            field: 'feedback',
            headerName: 'Feedback',
            width: 250,
        },
        {
            field: 'createdDtm',
            headerName: 'Date',
            width: 180,
            valueGetter: (params) => {
                return getTimeWithTimeZone(params.value).format('YYYY-MM-DD HH:mm');
            },
        },
    ];

    const rows = [
        {
            name: 'Peter chan',
            feedback: 'this is demo feedback message',
            createdDtm: new Date(),
            
        },
    ];

    return { rows: rows, columns: columns };
};

export default useReviewerFeedback;
